import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";
import FormSelect from "Common/Custom/FormSelect";
import FormTextarea from "Common/Custom/FormTextarea";

const BedsNo = Array.from({ length: 10 }, (_, i) => ({ id: i + 1 }));

const exbed_capability = [
    { status: "1", name: "Yes" },
    { status: "0", name: "No" },
];

// Uses `fields` prop from parent — does not re-import JSON directly
// roomTypeOptions and bedTypeOptions fetched in parent (EditRoom) — not inside this form
const EditRoomForm = ({
    fields = [],
    values,
    errors,
    handleChange,
    handleSubmit,
    loading,
    roomTypeOptions = [],
    bedTypeOptions = [],
    title = "Edit Room",
}) => {
    return (
        <PageBody
            headerchildren={<HeadingOne>{title}</HeadingOne>}
            onSubmit={handleSubmit}
        >
            {fields.map((field) => {
                if (field.name === "exbed_capability_limit" && values.exbed_capability != "1") {
                    return null;
                }
                if (field.type === "select") {
                    let options = [];
                    if (field.name === "exbed_capability") {
                        options = exbed_capability.map((opt) => ({ value: opt.status, label: opt.name }));
                    }
                    if (field.name === "room_size_mesurement") {
                        options = roomTypeOptions.map((opt) => ({ value: opt.mesurementid, label: opt.roommesurementitle }));
                    }
                    if (field.name === "beds_no") {
                        options = BedsNo.map((opt) => ({ value: opt.id, label: opt.id }));
                    }
                    if (field.name === "beds_type") {
                        options = bedTypeOptions.map((opt) => ({ value: opt.beds_typeid, label: opt.beds_typetitle }));
                    }
                    return (
                        <FormSelect
                            key={field.name}
                            field={field}
                            value={field.name === "exbed_capability" ? String(values[field.name]) : values[field.name]}
                            handleChange={handleChange}
                            options={options}
                            error={errors[field.name]}
                        />
                    );
                }
                if (field.type === "textarea") {
                    return (
                        <FormTextarea
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            error={errors[field.name]}
                        />
                    );
                }
                if (field.type === "switch") {
                    return (
                        <Switch
                            key={field.name}
                            values={values[field.name]}
                            handleChange={handleChange}
                            field={field}
                            ValueOne="1"
                            ValueTwo="0"
                            LabelOne="Active"
                            LabelTwo="Inactive"
                        />
                    );
                }
                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label="Update Room"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default EditRoomForm;
